// extracted by mini-css-extract-plugin
export default {"errorMessage":"webpack-components-FileUploadDialog-components-DragAndDropFileUploader-module__errorMessage"};